import {
  mapArtistType,
  mapLinkableEntityType,
  useFindAllContractingCompaniesSuspense,
  useFindAllContractingPersonsSuspense,
  useFindArtistSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/artists/$id.finance';
import {
  ContractingPartyTable,
  EditArtistContractingPartyForm,
} from './components';

export const ArtistContractingParty: React.FC = () => {
  const { t } = useTranslation('artistDetailsFinance');
  const { id } = Route.useParams();
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { data: artist } = useFindArtistSuspense(id, {
    query: { select: (data) => mapArtistType(data.data) },
  });
  const { data: allPersons } = useFindAllContractingPersonsSuspense({
    query: {
      select: (data) => data.data.map(mapLinkableEntityType),
    },
  });
  const { data: allCompanies } = useFindAllContractingCompaniesSuspense({
    query: {
      select: (data) => data.data.map(mapLinkableEntityType),
    },
  });
  const { hasPermission } = usePermissionContext();

  const userCanEditArtist = hasPermission({
    permission: 'FINANCE',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="artist-contracting-party-card">
        <TouringCardHeader>
          <TouringCardTitle>{t('CONTRACTING_PARTY.TITLE')}</TouringCardTitle>
          <TouringCardActions>
            {userCanEditArtist && <EditActionIcon onClick={openModal} />}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <ContractingPartyTable artist={artist} />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        size="md"
        title={t('EDIT_MODAL.TITLE')}
      >
        <EditArtistContractingPartyForm
          artist={artist}
          allPersons={allPersons}
          allCompanies={allCompanies}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
